import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  checklistTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  ProjectApprovalsAssignments,
  IProjectApprovalsAssignments,
} from '@core/entities/project/ProjectApprovalsAssignments'

export const useGetProjectChecklistApprovalsAssignments = (
  payload: RequestTypes['getProjectChecklistApprovalsAssignments'],
  options?: UseQueryOptions<
    IProjectApprovalsAssignments,
    RequestErrorType,
    ProjectApprovalsAssignments
  >,
) => {
  return useQuery({
    ...checklistTemplateKeys.getProjectApprovalsAssignments(payload),
    select: (data) => ProjectApprovalsAssignments.new(data),
    ...options,
  })
}
